<div class="col-md-12" style="position: relative; top:-8px">
  <select [ngModel]="drawingService.selectedViewName"  (change)="onChange($event.target.value)">
    <option [value]='null'>
      Default View
    </option>
    <option [value]='view.viewName'  *ngFor="let view of views">
        {{view.viewName}}
    </option>
  </select>
 </div>
